<script lang="ts">
  import { onDestroy } from 'svelte';
  import { isTvWindow, openTvWindow } from '../lib/tvWindow';

  let { size = 'normal' }: { size?: 'normal' | 'small' } = $props();
  const small = $derived(size === 'small');
  const inTv = isTvWindow();
  let blocked = $state(false);
  let justOpened = $state(false);
  let timer: ReturnType<typeof setTimeout> | undefined;
  function open() {
    blocked = !openTvWindow();
    // Small variant: reveal the cast hint inline for a few seconds after a successful open.
    justOpened = !blocked;
    clearTimeout(timer);
    if (justOpened) timer = setTimeout(() => (justOpened = false), 6000);
  }
  onDestroy(() => clearTimeout(timer));
</script>

{#if !inTv}
  <div class="tv" class:small>
    <button type="button" class="tv-btn" aria-describedby={small ? 'tv-hint' : undefined} onclick={open}>
      {small ? '📺 TV window' : '📺 Open TV window (16:9)'}
    </button>
    <p id="tv-hint" class="hint" class:tip={small} class:show={!small || justOpened}>Then cast this new window: ⋮ → Cast… → Cast tab</p>
    {#if blocked}
      <p class="blocked" class:tip={small} role="alert">The pop-up was blocked. Allow pop-ups for this site in your browser, then try again.</p>
    {/if}
  </div>
{/if}

<style>
  .tv { display: flex; flex-direction: column; align-items: center; gap: 0.3rem; position: relative; }
  .tv-btn {
    font: inherit; font-weight: 800; font-size: clamp(1rem, 1.6vw, 1.3rem); color: var(--cyan); cursor: pointer;
    padding: 0.4em 1.2em; border-radius: 999px; background: rgba(125, 249, 255, 0.08); border: 2px solid rgba(125, 249, 255, 0.5);
  }
  .tv-btn:hover { box-shadow: 0 0 14px rgba(125, 249, 255, 0.5); }
  .hint { margin: 0; font-size: clamp(0.85rem, 1.2vw, 1rem); opacity: 0.7; }
  .blocked { margin: 0; color: #ff8fa3; font-weight: 700; max-width: 40ch; }

  .small .tv-btn {
    font-weight: 700; font-size: clamp(0.9rem, 1.15vw, 1.1rem); padding: 0.35em 0.9em; color: rgba(255, 255, 255, 0.8);
    background: transparent; border: 1.5px solid rgba(255, 255, 255, 0.28); box-shadow: none;
  }
  .small .tv-btn:hover, .small .tv-btn:focus-visible { color: var(--cyan); border-color: rgba(125, 249, 255, 0.7); }
  /* Tooltip floating above the chip so the bottom-left group never grows. */
  .tip {
    position: absolute; bottom: calc(100% + 0.5rem); left: 0; width: max-content; max-width: min(24ch, 80vw);
    padding: 0.5em 0.8em; border-radius: 10px; background: #1a0a38; border: 1px solid rgba(125, 249, 255, 0.45);
    font-size: clamp(0.9rem, 1.15vw, 1.05rem); opacity: 1; z-index: 5; text-align: left;
  }
  .hint.tip { display: none; }
  .hint.tip.show, .small:hover .hint.tip, .small:focus-within .hint.tip { display: block; }
  .blocked.tip { color: #ff8fa3; }
</style>
